import { viewSchemas } from "@redotech/redo-model/views/views";
import * as z from "zod/v4";

export const getBulkFulfillmentView = {
  name: "getBulkFulfillmentView" as const,
  input: z.object({}),
  output: z.object({ view: viewSchemas["bulk-fulfillments"] }),
};
